import { defaultInteractionOptions } from "@common/components/helpers/options/interactionOptions";
import BaseReducer from "./BaseReducer";

class InteractionOptionsReducer extends BaseReducer {
  domain = "InteractionOptions";
  type = "View";

  initialState = {
    // Loading flag for the Select components
    loadingOptions: false,
    // Options for various customer interaction Select components
    customerInteractionOptions: defaultInteractionOptions,
  };
}

const reducer = new InteractionOptionsReducer();

export default reducer;
